import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=40aa5fbc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=40aa5fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa5fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40aa5fbc')) {
      api.createRecord('40aa5fbc', component.options)
    } else {
      api.reload('40aa5fbc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=40aa5fbc&scoped=true&", function () {
      api.rerender('40aa5fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GPLuc6szYyT9/JS/comp/Voucher.vue"
export default component.exports